import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { loadRepoListPage } from '@/server/functions/pages/repo-list';
import { getRepo } from '@/server/functions/repo';

export type RepoListPageOpts = {
  tags?: string[];
  search?: string;
  sortBy?: 'name' | 'createdAt';
  sortOrder?: 'asc' | 'desc';
};

export const repoListQueryKey = (orgSlug: string, opts?: RepoListPageOpts) =>
  ['repo-list-page', orgSlug, opts ?? {}] as const;

export const repoListQueryFn =
  (orgSlug: string, opts?: RepoListPageOpts) =>
  ({ pageParam }: { pageParam: string | undefined }) =>
    loadRepoListPage({
      data: {
        orgSlug,
        tags: opts?.tags,
        search: opts?.search,
        cursor: pageParam,
        sortBy: opts?.sortBy,
        sortOrder: opts?.sortOrder,
      },
    });

export const repoListInfiniteQueryOptions = (orgSlug: string, opts?: RepoListPageOpts) =>
  infiniteQueryOptions({
    queryKey: repoListQueryKey(orgSlug, opts),
    queryFn: repoListQueryFn(orgSlug, opts),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  });

export const repoQueryOptions = (orgSlug: string, name: string) =>
  queryOptions({
    queryKey: ['repo', orgSlug, name],
    queryFn: () => getRepo({ data: { orgSlug, name } }),
  });
